/**
 * The KYC table that also shows the name each identity document printed, and the collapsible
 * section it sits in.
 *
 * **Components, not views.** Neither makes an API call, so neither meets ADR 62's definition of a
 * View Component, which is one that is API endpoint specific and handles the request itself. They
 * take rows to render and a confidence level as props and render.
 *
 * **Dumb and presentational, by design.** Turning a customer's identity documents into rows means
 * knowing the API's own document shapes (a licence's structured name fields, a passport's, the
 * legacy whole-name fallback both still need) and composing a name out of them, which is a views
 * concern, not a component's. That mapping, `documentRows`, lives in `@verifime/views` alongside the
 * types it reads. These components take the already-built row and never see a licence or a
 * passport shape.
 */
export { default as KycWithNames } from './KycWithNames';
export type { TKycWithNamesProps } from './KycWithNames';

export { default as KycVerificationSection } from './KycVerificationSection';
export type { TKycVerificationSectionProps } from './KycVerificationSection';
